import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { CoreModule } from "@modules/core/core.module";
import { AddressBookCreateWalletPersonTypeModalComponent } from "../address-book-create-wallet-person-type-modal/address-book-create-wallet-person-type-modal.component";
import {
	AddressBookWalletModel,
	AddressBookWalletModelAsset,
	AddressBookWalletViewType,
	AddressBookWalletModelNetwork,
	OwnerType,
	WalletType
} from "../model/address-book-wallet.model";

import { config } from "@config";

@Component({
	selector: "app-address-book-create-wallet-type-modal",
	imports: [CoreModule],
	templateUrl: "./address-book-create-wallet-type-modal.component.html",
	styleUrl: "./address-book-create-wallet-type-modal.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressBookCreateWalletTypeModalComponent {
	@Input() set data({
		type,
		wallet,
		accountWalletId,
		selectedNetwork,
		selectedCryptocoin,
		ownerType,
		SHW3rdPartyDisabled
	}) {
		this.modalType = type;
		this.wallet = wallet;
		this.accountWalletId = accountWalletId;
		this.selectedNetwork = selectedNetwork;
		this.selectedCryptocoin = selectedCryptocoin;
		this.ownerType = ownerType;
		this.SHW3rdPartyDisabled = SHW3rdPartyDisabled;
	}

	public modalType: AddressBookWalletViewType = AddressBookWalletViewType.NEW;
	public wallet?: AddressBookWalletModel;
	public accountWalletId?: string;
	public selectedNetwork?: AddressBookWalletModelNetwork;
	public selectedCryptocoin?: AddressBookWalletModelAsset;
	public ownerType?: OwnerType;
	public addressBookWalletViewType = AddressBookWalletViewType;
	public walletType = WalletType;
	public learnMoreUrl: string = config.externalPaths["travel_rule"]["faq"];
	private SHW3rdPartyDisabled: boolean;

	public get modalTitle(): string | null {
		if (this.modalType === AddressBookWalletViewType.WITHDRAW && this.selectedCryptocoin && this.selectedNetwork) {
			return "send_via";
		}
		return null;
	}

	constructor(private readonly modalService: ModalService) {}

	public isBusinessOwnerType(): boolean {
		return this.ownerType === OwnerType.LEGAL_ENTITY;
	}

	public cancel(): void {
		this.modalService.popAll();
	}

	public back(): void {
		this.modalService.pop();
	}

	public selectWalletType(walletType: WalletType): void {
		// Always use the unified person type modal for both person and legal entity
		this.modalService.showModal(AddressBookCreateWalletPersonTypeModalComponent, {
			type: this.modalType,
			wallet: this.wallet,
			accountWalletId: this.accountWalletId,
			selectedNetwork: this.selectedNetwork,
			selectedCryptocoin: this.selectedCryptocoin,
			ownerType: this.ownerType,
			walletType: walletType,
			SHW3rdPartyDisabled: this.SHW3rdPartyDisabled
		});
	}
}
